import { RemoveTeamMemberFnReq, RemoveTeamMemberFnRes } from '@uploadcam/common';
import { Functions, httpsCallable } from 'firebase/functions';

export class RemoveTeamMemberInteractor {
  private readonly removeTeamMemberFn = httpsCallable<RemoveTeamMemberFnReq, RemoveTeamMemberFnRes>(
    this.functions,
    'removeTeamMember',
  );

  constructor(private readonly functions: Functions) {}

  public async execute(userId: string): Promise<void> {
    await this.removeTeamMemberFn({ userId });
  }
}
